module.exports = __webpack_public_path__ + "newhomeassets/media/cda.b02e3963.xsl";